"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var VerticalRatio = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M17,21.007983 L17,2.99201702 C17,2.45014743 16.5487268,2 15.9972399,2 L8.00276013,2 C7.44594575,2 7,2.444032 7,2.99201702 L7,21.007983 C7,21.5498526 7.45127322,22 8.00276013,22 L15.9972399,22 C16.5540542,22 17,21.555968 17,21.007983 Z M18,21.007983 C18,22.1081436 17.1064574,23 15.9972399,23 L8.00276013,23 C6.89666625,23 6,22.0998238 6,21.007983 L6,2.99201702 C6,1.8918564 6.89354265,1 8.00276013,1 L15.9972399,1 C17.1033337,1 18,1.90017617 18,2.99201702 L18,21.007983 Z" })));
};
VerticalRatio.displayName = 'VerticalRatio';
exports.default = VerticalRatio;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=VerticalRatio.js.map